import { render, staticRenderFns } from "./VideoMod.vue?vue&type=template&id=37dc2446&scoped=true"
import script from "./VideoMod.vue?vue&type=script&lang=js"
export * from "./VideoMod.vue?vue&type=script&lang=js"
import style0 from "./VideoMod.vue?vue&type=style&index=0&id=37dc2446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc2446",
  null
  
)

export default component.exports